import _ from 'underscore';
import AppView from '@/data/views/app';
import Backbone from 'backbone';
import A11yDialog from 'a11y-dialog';

export default Backbone.Router.extend({
  routes: {
    'categories/:slug': 'registerCategory',
    ':id': 'activateDataSet',
    '': 'hideModal'
  },

  initialize: function() {
    this.params = {
      'page': 1
    };
    this.category = null;
    this.history = '';

    // Use A11yDialog (wrapping a Bootstrap modal HTML markup), since
    // A11yDialog has more control over scrolling behavior to allow for
    // horizontal scrolling and panning on mobile, since many of our charts are
    // too wide for narrow mobile widths. So this is a case where we actually
    // want the modal to expand beyond the normal viewport and allow mobile
    // users to pan and zoom around. It's maybe not the best mobile experience,
    // but seems like maybe the best option given the density of information in
    // some of these charts.
    //
    // Bootstrap's default modal implementation prevents horizontal scrolling
    // (due to
    // https://github.com/twbs/bootstrap/blob/v5.3.3/js/src/util/scrollbar.js#L59-L62).
    //
    // With A11yDialog's less opinionated approach, we can implement a simpler
    // approach to lock vertical scrolling on the underlying body, but still
    // allow horizontal scrolling:
    // https://a11y-dialog.netlify.app/advanced/scroll-lock
    //
    // The more robust libraries like
    // https://github.com/willmcpo/body-scroll-lock and
    // https://github.com/tuax/tua-body-scroll-lock seem to also lock
    // horizontal scrolling, so while they may handle more edge cases, we'll go
    // with this simpler approach.
    const modalEl = document.getElementById('chartModal')
    this.modal = new A11yDialog(modalEl);
    this.modal.on('show', () => {
      document.documentElement.style.overflowY = 'hidden';
    }).on('hide', () => {
      document.documentElement.style.overflowY = '';
      window.app.navigateTo();
      document.title = 'Alternative Fuels Data Center: Maps and Data';

      // If the page was loaded server-side to view a specific dataset (eg,
      // `/data/10641`), then the `h1` will contain the title of the dataset.
      // This resets the `h1` back to the default when that modal is closed. We
      // do not update the `h1` for client-side views, so this only occurs on
      // that initial server-side rendering.
      document.querySelector('h1').innerHTML = 'Maps and Data';
    });

    //initialize views...
    this.app_view = new AppView();

    this.appRoot = '/data';

    Backbone.history.start({
      pushState: true,
      root: this.appRoot
    });
  },

  activateDataSet: function(id) {
    if (id.match(/^\d+$/)) {
      this.app_view.updateModel(id, _.bind(this.showModal, this));
    }
  },

  navigateTo: function(id) {
    var path = '';
    if (id !== undefined) {
      path += id;
    } else {
      path = this.history;
    }
    this.navigate(path, { trigger: true});
  },

  showModal: function() {
    this.modal.show();
  },

  hideModal: function() {
    this.modal.hide();
  },

  registerCategory: function(slug) {
    this.category = slug;
  },
});
